// The phone number typed on the login / verify pages, kept so the sync-rewards flow can
// prefill it instead of asking for it a second time. Every access is guarded: private
// windows and blocked site data make localStorage throw rather than return null.
const PHONE_KEY = 'sync_phone'

const sanitize = (value) => String(value ?? '').replace(/[^0-9]/g, '').slice(0, 10)

const rememberPhone = (value) => {
  const phone = sanitize(value)
  try {
    if (phone) localStorage.setItem(PHONE_KEY, phone)
    else localStorage.removeItem(PHONE_KEY)
  }
  catch (e) { /* ignore */ }
}

const recallPhone = () => {
  try {
    return sanitize(localStorage.getItem(PHONE_KEY))
  }
  catch (e) {
    return ''
  }
}

export { rememberPhone, recallPhone }
